module.exports = __webpack_public_path__ + "static/media/common-modal-bg@2x.820f73fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/common-modal-bg@2x.png
// module id = 196
// module chunks = 0